// import { BIG_ZERO } from 'utils/bigNumber'
import { Text, useMatchBreakpoints } from "@pancakeswap/uikit";
import BigNumber from "bignumber.js";
// import { DeserializedPool } from 'state/types'
// import { useTranslation } from 'contexts/Localization'
import BaseCell, { CellContent } from "./BaseCell";
import Apr from "../../Apr";
import { BIG_ZERO } from "utils/bigNumber";
import { styled } from "@mui/material";

interface AprCellProps {
  pool: any;
  index : any;
}
// const StyledCell = styled(BaseCell)`
//   width:200px;
// `
const AprCell: React.FC<AprCellProps> = ({ pool,index }) => {
  // const { t } = useTranslation()
  const { isMobile } = useMatchBreakpoints();
  const { userData } = pool;
  const stakedBalance = userData?.stakedBalance
    ? new BigNumber(userData.stakedBalance)
    : BIG_ZERO;

  return (
    <BaseCell
      role="cell"
      width={["200px", "200px", "200px", "200px", "250px"]}
      // flex={["1 0 50px", "1 0 50px", "2 0 100px", "2 0 100px", "1 0 20px"]}
    // flex={"1 0 10px"}

    >
      {/* <StyledCell role="cell"> */}
        <CellContent>
          <Text fontSize="12px" color="#00FED9" textAlign="left">
            APR
          </Text>
          <Apr pool={pool} index={index} stakedBalance={stakedBalance} showIcon={!isMobile} />
        </CellContent>
      {/* </StyledCell> */}
    </BaseCell>
  );
};

export default AprCell;
